/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminResendInviteOptions, AdminResendInviteResponses } from '../../models/AdminResendInvite'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Resend Invite
 * {@link /admin/org/:org_id/invite/:invite_id/resend}
 */
export function adminResendInvite<ThrowOnError extends boolean = true>(options: Options<AdminResendInviteOptions, ThrowOnError>): Promise<UnwrappedResult<AdminResendInviteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/{org_id}/invite/{invite_id}/resend', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminResendInviteResponses, ThrowOnError>>
}
